import { Outlet } from 'react-router-dom';
import MainContent from '../../components/mainContent/MainContent';
import { BorrarConexionesContent } from './components/BorrarConexionesContent';

export default function BorrarConexiones() {
  return (
    <>
      <MainContent
        titulo='Borrar conexiones'
        component={<BorrarConexionesContent />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}